import { render, staticRenderFns } from "./UpdateCalendarPage.vue?vue&type=template&id=47d4b6c8&scoped=true"
import script from "./UpdateCalendarPage.vue?vue&type=script&lang=js"
export * from "./UpdateCalendarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4b6c8",
  null
  
)

export default component.exports